import React from 'react';
import { useContactModalContext } from '../../contexts/ContactModalContext';

const Button = ({ 
  children, 
  href, 
  variant = 'primary', 
  className = '',
  size = 'md',
  onClick,
  ...props 
}) => {
  const { openModal } = useContactModalContext();
  
  const baseClasses = 'inline-flex items-center justify-center rounded-md transition-all duration-300 touch-manipulation active:scale-95 font-medium';
  
  // Variantes
  const variants = {
    primary: 'bg-primary hover:bg-primary/90 text-white shadow-cta',
    secondary: 'border border-white/20 hover:border-primary/70 bg-dark-900/50 hover:bg-dark-800/70 text-white',
    outline: 'border border-primary/30 bg-dark-800/70 hover:bg-dark-700/70 text-white',
  };
  
  // Tamanhos responsivos
  const sizes = {
    sm: 'py-2 px-4 text-sm md:py-3 md:px-5',
    md: 'py-3 px-5 text-sm md:py-3 md:px-6 md:text-base',
    lg: 'py-4 px-6 text-base md:py-4 md:px-8 md:text-lg',
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  // Verificar se é um link do WhatsApp
  const isWhatsAppLink = href && href.includes('whatsapp.com');

  // Mensagem padrão para WhatsApp
  const whatsappMsg = 'Olá! Vim pelo site e quero saber mais sobre como funciona a troca de consoles.';

  // Se for link do WhatsApp, garantir que a mensagem esteja na URL
  let finalHref = href;
  if (isWhatsAppLink) {
    const url = new URL(href, window.location.origin);
    if (!url.searchParams.get('text')) {
      url.searchParams.set('text', whatsappMsg);
      finalHref = url.toString().replace(window.location.origin, 'https://api.whatsapp.com');
    }
  }

  const handleClick = (e) => {
    if (isWhatsAppLink) {
      // Redireciona direto para o WhatsApp
      return; // deixa o link seguir normalmente
    } else if (onClick) {
      onClick(e);
    }
  };

  if (href) {
    return (
      <a 
        href={finalHref} 
        className={classes} 
        onClick={handleClick}
        role="button"
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={classes} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button; 